import fadeBottom from './fade-bottom/index.es.js';
import fadeTop from './fade-top/index.es.js';
import flooded from './flooded/index.es.js';

/**
 * Coolwhip Variants List.
 */ var variants = {
    // fade-bottom
    'fade-bottom/green-blue-violet': fadeBottom.GreenBlueViolet,
    'fade-bottom/blue-violet-red': fadeBottom.BlueVioletRed,
    'fade-bottom/blue-red-orange': fadeBottom.BlueRedOrange,
    'fade-bottom/purple-violet-red': fadeBottom.PurpleVioletRed,
    'fade-bottom/orange-violet-blue': fadeBottom.OrangeVioletBlue,
    'fade-bottom/red-orange-green': fadeBottom.RedOrangeGreen,
    // fade-top
    'fade-top/green-blue-violet': fadeTop.GreenBlueViolet,
    'fade-top/blue-violet-red': fadeTop.BlueVioletRed,
    'fade-top/blue-red-orange': fadeTop.BlueRedOrange,
    'fade-top/purple-violet-red': fadeTop.PurpleVioletRed,
    'fade-top/orange-violet-blue': fadeTop.OrangeVioletBlue,
    'fade-top/red-orange-green': fadeTop.RedOrangeGreen,
    // flooded
    'flooded/green-orange-violet': flooded.GreenOrangeViolet,
    'flooded/violet-blue-green': flooded.VioletBlueGreen,
    'flooded/blue-violet-red-orange': flooded.BlueVioletRedOrange,
    'flooded/blue-orange-red': flooded.BlueOrangeRed,
    'flooded/purple-blue-red': flooded.PurpleBlueRed,
    'flooded/red-purple-green': flooded.RedPurpleGreen
};

export { variants as default };
//# sourceMappingURL=index.es.js.map
